import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { LogisticsActionKeys, SplitShipmentItem } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { IShipmentItem, ISplitShipmentItemRequest } from '../logisticsInterfaces';

function* splitShipmentItemSaga(action: SplitShipmentItem) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeSplit, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.setShipmentItems(response.value.value));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSplitShipmentItem() {
  yield takeEvery(LogisticsActionKeys.SPLIT_SHIPMENT_ITEM, splitShipmentItemSaga);
}

async function executeSplit(
  update: ISplitShipmentItemRequest
): Promise<IApiExecuteRespone<IEntityWithMessages<IShipmentItem[]>>> {
  return executeApiRequest(() => httpService.post(`${ApiUrls.shipmentItem(update.shipmentItemId)}/Split`, update));
}
